module.exports = __webpack_public_path__ + "img/background_Image_build.1832e488.png";